/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timezone_America_Losangeles3Inputs */

const he_timezone_america_losangeles3 = /** @type {(inputs: Timezone_America_Losangeles3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacific Time (US)`)
};

const en_timezone_america_losangeles3 = /** @type {(inputs: Timezone_America_Losangeles3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacific Time (US)`)
};

/**
* | output |
* | --- |
* | "Pacific Time (US)" |
*
* @param {Timezone_America_Losangeles3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const timezone_america_losangeles3 = /** @type {((inputs?: Timezone_America_Losangeles3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timezone_America_Losangeles3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_timezone_america_losangeles3(inputs)
	return en_timezone_america_losangeles3(inputs)
});
export { timezone_america_losangeles3 as "timezone_America_LosAngeles" }